import React from "react";
import './skills.css';
import html from "../../assets/html.png";
import css from "../../assets/css.png";
import c from "../../assets/c++.png";
import java from "../../assets/java.png";
import bootstrap from "../../assets/bootstrapCSS.png";
import mysql from "../../assets/mysql.png";
import js from "../../assets/js.png";
import python from "../../assets/python.png";
import react from "../../assets/react.webp";
import git from "../../assets/git.png";
import figma from "../../assets/figma.png";
import R from "../../assets/R.png";
import Tableau from "../../assets/tableau.png";
import Typescript from "../../assets/typescript.png";
import Next from "../../assets/next.png";
import Node from "../../assets/node.png";
import Tailwind from "../../assets/tailwindcss.png";
import PostgreSQL from "../../assets/postgreSQL.png"
import PowerBI from "../../assets/powerBI.png"
import Vite from "../../assets/vite.png"

export default function Skills() {
    const skills = [
        { name: "HTML", logo: html },
        { name: "CSS", logo: css },
        { name: "C++", logo: c },
        { name: "Java", logo: java },
        { name: "Bootstrap CSS", logo: bootstrap },
        { name: "MySQL", logo: mysql },
        { name: "Next.js", logo: Next },
        { name: "JavaScript", logo: js },
        { name: "React.js", logo: react },
        { name: "R", logo: R },
        { name: "Python", logo: python },
        { name: "Git", logo: git },
        { name: "Typescript", logo: Typescript },
        { name: "Tailwind CSS", logo: Tailwind },
        { name: "Node.js", logo: Node },
        { name: "Figma", logo: figma },
        { name: "Tableau", logo: Tableau },
        {name: "PostgreSQL", logo: PostgreSQL},
        {name: "Power BI", logo: PowerBI},
        {name: "Vite", logo: Vite}
      ];

      return (
        <section id="skills">
  <div className="skillscontent">
    <div className="skills-heading">
      <span className="mySkills">Skills</span>
    </div>
    <div className="skills-grid">
  {skills.map((skill, index) => (
    <figure className="skills-text" key={index}>
      <img src={skill.logo} alt={skill.name} className="skill-logo" />
      <figcaption className="skills-name">{skill.name}</figcaption>
    </figure>
  ))}
</div>
  </div>
</section>

      );

    // return (
    //     <section id="skills">
    //         <div className="skillscontent">
    //             <div className="skills-heading">
    //                 <span className="mySkills">Skills</span>
    //                 {/* <span className="skills-sub">These are some of my skills, and I am always eager to learn more</span> */}
    //             </div>
    //             <div className="one">
    //                 <figure className="skills-text">
    //                     <img src={html} alt="HTML" className="skill-logo"/>
    //                     <figcaption className="skills-name">HTML</figcaption>
    //                 </figure>
    //                 <figure className="skills-text">
    //                     <img src={css} alt="css" className="skill-logo"/>
    //                     <figcaption className="skills-name">CSS</figcaption>
    //                 </figure>
    //                 <figure className="skills-text">
    //                     <img src={c} alt="c" className="skill-logo"/>
    //                     <figcaption className="skills-name">C++</figcaption>
    //                 </figure>
    //                 <figure className="skills-text">
    //                     <img src={java} alt="java" className="skill-logo"/>
    //                     <figcaption className="skills-name">Java</figcaption>
    //                 </figure>
    //                 <figure className="skills-text">
    //                     <img src={bootstrap} alt="bootstrap" className="skill-logo"/>
    //                     <figcaption className="skills-name">Bootstrap CSS</figcaption>
    //                 </figure>
    //                 <figure className="skills-text">
    //                     <img src={mysql} alt="mysql" className="skill-logo"/>
    //                     <figcaption className="skills-name">MySQL</figcaption>
    //                 </figure>
    //                 <figure className="skills-text">
    //                     <img src={js} alt="js" className="skill-logo"/>
    //                     <figcaption className="skills-name">JavaScript</figcaption>
    //                 </figure>
    //                 <figure className="skills-text">
    //                     <img src={Next} alt="next" className="skill-logo"/>
    //                     <figcaption className="skills-name">Next.js</figcaption>
    //                 </figure>
                    
    //             </div>
    //             <div className="two">
    //             <figure className="skills-text">
    //                     <img src={react} alt="react" className="skill-logo"/>
    //                     <figcaption className="skills-name">React.js</figcaption>
    //                 </figure>
    //                 <figure className="skills-text">
    //                     <img src={R} alt="R" className="skill-logo"/>
    //                     <figcaption className="skills-name">R</figcaption>
    //                 </figure>
    //                 <figure className="skills-text">
    //                     <img src={python} alt="python" className="skill-logo"/>
    //                     <figcaption className="skills-name">Python</figcaption>
    //                 </figure>
    //                 <figure className="skills-text">
    //                     <img src={git} alt="git" className="skill-logo"/>
    //                     <figcaption className="skills-name">Git</figcaption>
    //                 </figure>
    //                 <figure className="skills-text">
    //                     <img src={Typescript} alt="typescript" className="skill-logo"/>
    //                     <figcaption className="skills-name">Typescript</figcaption>
    //                 </figure>
    //                 <figure className="skills-text">
    //                     <img src={Tailwind} alt="tailwind" className="skill-logo"/>
    //                     <figcaption className="skills-name">Tailwind CSS</figcaption>
    //                 </figure>
    //                 <figure className="skills-text">
    //                     <img src={Node} alt="node" className="skill-logo"/>
    //                     <figcaption className="skills-name">Node.js</figcaption>
    //                 </figure>
    //             </div>
                
    //             <div className="three">
    //                 <figure className="skills-text">
    //                     <img src={figma} alt="figma" className="skill-logo"/>
    //                     <figcaption className="skills-name">Figma</figcaption>
    //                 </figure>
    //                 <figure className="skills-text">
    //                     <img src={Tableau} alt="tableau" className="skill-logo"/>
    //                     <figcaption className="skills-name">Tableau</figcaption>
    //                 </figure>

    //             </div>
                
    //         </div>
    //     </section>
    // );
}